var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mos",attrs:{"aria-live":"polite"}},[_c('p',{staticClass:"mos-total",class:{ 'mos-total--empty': !_vm.hasItems }},[_vm._v(_vm._s(_vm.totalLabel))]),(_vm.itemsLabel)?_c('p',{staticClass:"mos-items",attrs:{"title":_vm.itemsLabel}},[_vm._v(_vm._s(_vm.itemsLabel))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }